import { moduleFactory } from "@/factories/module";
import { clientEnvBuildInfo } from "@/modules/client-env/buildInfo";
import {
  clearClientEnvClientGroupId,
  clientEnvClientGroupId,
} from "@/modules/client-env/clientGroupId";
import { clearClientEnvClientId, clientEnvClientId } from "@/modules/client-env/clientId";
import { clientEnvGetElectricBaseUrl } from "@/modules/client-env/electric";
import { clientEnvIsDesktop } from "@/modules/client-env/isDesktop";
import {
  clientEnvNodeEnvironment,
  clientEnvNodeEnvironmentIsDev,
  clientEnvNodeEnvironmentIsProd,
  clientEnvNodeEnvironmentIsTest,
} from "@/modules/client-env/nodeEnvironment";
import { clientEnvPackageVersion } from "@/modules/client-env/packageVersion";
import { clientEnvPlatformKind } from "@/modules/client-env/platformKind";
import { clientEnvPosthogProjectApiKey } from "@/modules/client-env/posthogConfig";
import { clientEnvStripeConfig } from "@/modules/client-env/stripeConfig";
import { clientEnvLocalBackendApiIsEnabled } from "@/modules/client-env/viteConfig";

export const clientEnvModule = moduleFactory.create({
  nodeEnv: clientEnvNodeEnvironment,
  isProd: clientEnvNodeEnvironmentIsProd,
  isDev: clientEnvNodeEnvironmentIsDev,
  isTest: clientEnvNodeEnvironmentIsTest,
  localBackendApiIsEnabled: clientEnvLocalBackendApiIsEnabled,
  clientId: clientEnvClientId,
  clientGroupId: clientEnvClientGroupId,
  stripe: clientEnvStripeConfig,
  buildInfo: clientEnvBuildInfo,
  packageVersion: clientEnvPackageVersion,
  isDesktop: clientEnvIsDesktop,
  clearClientId: clearClientEnvClientId,
  clearClientGroupId: clearClientEnvClientGroupId,
  platformKind: clientEnvPlatformKind,
  posthogProjectApiKey: clientEnvPosthogProjectApiKey,
  getElectricBaseUrl: clientEnvGetElectricBaseUrl,
});
